// Constants file
import Constants from '../constants/AppConstants';
import { WebsiteConfigurations } from '../constants/ConfigConstants';

export const getApiConfigurations = () => {
  const user = JSON.parse(localStorage.getItem(Constants.FIELD.USER));
  const configurations = {
    baseUrl: process.env.REACT_APP_API_HOST_URL,
    userId: user._id,
    token: localStorage.getItem(Constants.FIELD.AUTH_TOKEN),
    tenantId: localStorage.getItem(Constants.FIELD.TENANT_ID),
    subTenantId: user.subTenantId,
  };
  return configurations;
};

export const getThemeConfigurations = () => {
  const configurations = getWebsiteConfiguration();
  const theme = configurations?.theme || Constants.SYSTEM.DEFAULT_THEME;
  const themeConfigurations = {
    textAlternate: theme['--text-alternate'],
    textSecondary: theme['--text-secondary'],
    textPrimary: theme['--text-primary'],
    backgroundSecondary: theme['--bg-secondary'],
    backgroundPrimary: theme['--bg-primary'],
    primary: theme['--primary'],
  };
  return themeConfigurations;
};

export const getWebsiteConfiguration = () => {
  const domain = new URL(window.location);
  const hostName = domain.hostname;
  for (const item of WebsiteConfigurations) {
    if (hostName.includes(item.domainName)) {
      return item;
    }
  }
  return WebsiteConfigurations.find((item) => item.domainName === 'default');
};

export const getDomain = (url) => {
  url = url.replace(/(https?:\/\/)?(www.)?/i, '');
  if (url.indexOf('/') !== -1) {
    return url.split('/')[0];
  }
  return url;
};

export const getTimeZone = () => {
  const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const staticTimeZone = localStorage.getItem('timeZone');
  if (staticTimeZone) {
    return staticTimeZone;
  }
  return defaultTimeZone;
};

export const iframeValidation = () => {
  if (window !== window.parent) {
    return true;
  } else {
    return false;
  }
};
